import { S3File } from "features/file-browser/state/fileAtoms";

const downloadFile = (
  s3file: S3File,
  delay: number
) => {
  setTimeout(() => {
    try {
      if (s3file.url !== '') {
        const link = document.createElement('a');
        link.href = s3file.url;
        link.setAttribute('download', `${s3file.path}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode!.removeChild(link);
      } else {
        alert('No file URL available.');
      }
    } catch (error) {
      console.error(`Error downloading the file: ${error}`);
    }
  }, delay);
};

export const handleDownloadButtonClick = (
  filesToDownload: S3File[],
) => {
  filesToDownload.forEach((file, index) => downloadFile(file, index * 1000));
};
